<img [src]="src" [alt]="alt" (click)="zoomImage()">